import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../styles.css";

const Recording = () => {
  const images = [
    "/studio1.jpg",
    "/studio2.jpg",
    "/studio3.jpg",
    "/studio4.jpg",
  ];

  const [modalImage, setModalImage] = useState(null);

  const openModal = (src) => {
    setModalImage(src);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div className="page-container">
      <h1>Recording</h1>
      <p>Our state-of-the-art studio is ready for your next recording session.</p>

      {/* Image Carousel */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 20000, disableOnInteraction: false }}
        loop={true}
        className="recording-carousel"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <img
              src={src}
              alt={`Studio ${index + 1}`}
              className="studio-image"
              onClick={() => openModal(src)} // Open full-screen modal on click
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Cross Fire Records Section */}
      <div className="crossfire-section">
        <h2>Cross Fire Records</h2>
        <p>
          The recording division of X Fire Music.
          <br />
          Since 2007, we've been capturing sound across eras—from tape to CD to digital—seamlessly blending analog warmth with modern precision.
          <br />
          Where the old meets the new, and the new embraces the old—preserving the past, shaping the present, and inspiring the future.
        </p>
      </div>

      {/* Full-Screen Modal */}
      {modalImage && (
        <div className="image-modal" onClick={closeModal}>
          <span className="close-btn" onClick={closeModal}>&times;</span>
          <img src={modalImage} alt="Full View" className="full-screen-image" />
        </div>
      )}
    </div>
  );
};

export default Recording;


